import type {
  DefaultResponseBody,
  SiteUser,
  SiteUserProfile,
  SiteUserUpdateInput,
} from "@gerama/types";
import type { ApiClient } from "../client";

/** The signed-in listener's own profile — `GET/PATCH /users/me` and the avatar upload. */
export function createCoreUsersApi(client: ApiClient) {
  return {
    me: (signal?: AbortSignal) =>
      client
        .request<DefaultResponseBody<SiteUserProfile>>("/users/me", { signal })
        .then((res) => res.data as SiteUserProfile),

    updateMe: (body: SiteUserUpdateInput) =>
      client
        .request<DefaultResponseBody<SiteUser>>("/users/me", { method: "PATCH", body })
        .then((res) => res.data as SiteUser),

    /** Multipart `file` — JPG/PNG/WebP/GIF/AVIF, up to 5 MB. Returns the updated profile. */
    uploadAvatar: (file: File | Blob) => {
      const formData = new FormData();
      formData.append("file", file);
      return client
        .request<DefaultResponseBody<SiteUser>>("/users/me/avatar", {
          method: "POST",
          body: formData,
          isFormData: true,
        })
        .then((res) => res.data as SiteUser);
    },

    removeAvatar: () =>
      client
        .request<DefaultResponseBody<SiteUser>>("/users/me/avatar", { method: "DELETE" })
        .then((res) => res.data as SiteUser),
  };
}
